import { ShowContextProvider, Title, useEditController } from "react-admin";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { IdChip } from "../../components/IdChip";
import { RoleStatusChip } from "../../components/RoleStatusChip";
import { colors } from "../../data/tokens";

// Ficha no padrão das Categorias de Sócios: nome em destaque com o chip
// na mesma cor da ficha do sócio e o identificador técnico copiável —
// a versão antiga listava "ID" e "Nome" crus.
export const UserRoleStatusShow = () => {
  const { id } = useParams();
  const controller: any = useEditController({
    resource: "user-role-status/crud",
    id,
  });
  const record = controller?.record;

  return (
    <ShowContextProvider value={controller}>
      <Title title="Status de Cargos e Funções" />
      <PageTopBreadcrumb
        title="Status de Cargos e Funções"
        firstPath="/#/user-role-status/crud"
        secondTitle="Visualizando"
        thirdTitle={record?.name}
        actionType="edit"
      />
      {record && (
        <Card sx={{ marginBottom: 3 }}>
          {/* Box em vez de CardContent: o App.css zera o padding de todo
              .MuiCardContent-root com !important */}
          <Box sx={{ padding: { xs: 2.5, md: 4 } }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                flexWrap: "wrap",
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: 17,
                  fontWeight: 700,
                  color: colors.primaryDark,
                }}
              >
                Status do Cargo
              </Typography>
              <RoleStatusChip name={record.name} />
            </Box>

            <Divider sx={{ marginY: 2.5 }} />

            <Typography sx={{ fontSize: 12, color: colors.textMuted }}>
              Identificador técnico
            </Typography>
            <Box sx={{ marginTop: 0.5 }}>
              <IdChip value={record.id} />
            </Box>
          </Box>
        </Card>
      )}
    </ShowContextProvider>
  );
};
